import { MenuItems } from "./menu-items/menu-items";
import { AccordionAnchorDirective, AccordionLinkDirective, AccordionDirective } from "./accordion";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import {
  MatFormFieldModule,
  MatDatepickerModule,
  MatInputModule,
  MatOptionModule,
  MatSelectModule,
  MatRadioModule,
  MatTableModule,
  MatButtonModule,
  MatIconModule,
  MatToolbarModule,
  MatSidenavModule,
  MatListModule,
  MatMenuModule,
  MatSlideToggleModule,
} from "@angular/material";
import { MatTabsModule } from "@angular/material/tabs";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { MatNativeDateModule } from "@angular/material/core";
import { SpinnerComponent } from "./spinner/spinner.component";
import { NgxChartsModule } from "@swimlane/ngx-charts";
import { GoogleChartsModule } from "angular-google-charts";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { Ng2TelInputModule } from "ng2-tel-input";
 import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { MatCheckboxModule } from "@angular/material/checkbox";
@NgModule({
  declarations: [AccordionAnchorDirective, AccordionLinkDirective, AccordionDirective, SpinnerComponent],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    MatOptionModule,
    MatIconModule,
    MatSelectModule,
    MatTabsModule,
    MatToolbarModule,
    MatSidenavModule,
    MatSlideToggleModule,
    MatRadioModule,
    MatSnackBarModule,
    MatMenuModule,
    MatTableModule,
    MatButtonModule,
    MatListModule,
    NgxDatatableModule,
    SpinnerComponent,
    NgxChartsModule,
    GoogleChartsModule,
    Ng2TelInputModule,
     NgMultiSelectDropDownModule,
    MatCheckboxModule,
    
  ],
  providers: [MenuItems],
})
export class SharedModule {}
